import { OnInit, Directive, ViewContainerRef, TemplateRef, Input } from '@angular/core';
import { AbTestService } from '../services/ab-test.service';

/**
 * template helper for tests. Example usage
 * <ng-container *abTestVersion="'v1';scope:'test1'">I am only for v1 users for test 'test1'</ng-container>
 * <ng-container *abTestVersion="'v2';scope:'test1'">I am only for v2 users for test 'test1'</ng-container>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[abTestVersion]'
})
export class AbTestVersionDirective implements OnInit {
  private scope: string;
  private version: string;

  constructor(
    private abTestService: AbTestService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<Element>
  ) {}

  ngOnInit(): void {
    // get version to display to the user and compare it with given version
    if (this.version.split(',').includes(this.abTestService.getVersion(this.scope))) {
      // User experiment version is v1, given version matches, render template
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  @Input() set abTestVersionScope(value: string) {
    this.scope = value;
  }

  @Input() set abTestVersion(value: string) {
    this.version = value;
  }
}
